import QuestionSkillTask from "@/views/Question/QuestionSkillTask";
import QuestionSkillCreate from "@/views/Question/QuestionSkillCreate";
import QuestionSkillMy from "@/views/Question/QuestionSkillMy";
import QuestionSkillMyDetail from "@/views/Question/QuestionSkillMyDetail";
import QuestionSkillImport from "@/views/Question/QuestionSkillImport";
import QuestionProofreadTask from "@/views/Question/QuestionProofreadTask";
import QuestionProofreadMyDetail from "@/views/Question/QuestionProofreadMyDetail";
import QuestionProofreadMy from "@/views/Question/QuestionProofreadMy";
import QuestionExamineTask from "@/views/Question/QuestionExamineTask";
import QuestionExamineMy from "@/views/Question/QuestionExamineMy";
import QuestionDetail from "@/views/Question/QuestionDetail";
import QuestionQualityInspection from "@/views/Question/QuestionQualityInspection";
import QuestionQualityInspectionMy from "@/views/Question/QuestionQualityInspectionMy";
import SpotCheck from "@/views/Spot/SpotCheck";
export default [
  {
    path: "question",
    name: "question",
    component: { render: h => h("router-view") },
    meta: {
      nav: {
        icon: "el-icon-s-marketing",
        title: "技能题库"
      },
      breadcrumb: {
        title: "挑战题库",
        replace: false
      }
    },
    children: [
      {
        path: "skill",
        name: "QuestionSkill",
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            title: "技能出题"
          },
          breadcrumb: {
            title: "技能出题",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "QuestionSkillTask",
            redirect: { name: "QuestionSkillTaskSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionSkillTaskSelf",
                component: QuestionSkillTask,
                permission:
                  "question.api.fuwu_admin.skill_question_tasks.index",
                meta: {
                  title: "极客-技能出题-出题任务",
                  nav: {
                    title: "出题任务"
                  },
                  breadcrumb: {
                    title: "出题任务",
                    replace: false
                  }
                }
              },
              {
                path: ":id/create",
                name: "QuestionSkillCreate",
                component: QuestionSkillCreate,
                permission: "question.api.fuwu_admin.skill_questions.store",
                meta: {
                  title: "极客-技能出题",
                  breadcrumb: {
                    title: "出题",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "import",
            name: "QuestionSkillImport",
            redirect: { name: "QuestionSkillImportSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionSkillImportSelf",
                component: QuestionSkillImport,
                permission:
                  "question.api.fuwu_admin.skill_question_import.store",
                meta: {
                  title: "极客-技能出题-批量上传",
                  nav: {
                    title: "批量上传"
                  },
                  breadcrumb: {
                    title: "批量上传",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "QuestionSkillMy",
            redirect: { name: "QuestionSkillMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionSkillMySelf",
                component: QuestionSkillMy,
                permission: "question.api.fuwu_admin.skill_questions.index",
                meta: {
                  title: "极客-工作记录-我的出题",
                  nav: {
                    title: "我的出题"
                  },
                  breadcrumb: {
                    title: "我的出题",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "QuestionSkillMyDetail",
                permission: "question.api.fuwu_admin.skill_questions.show",
                component: QuestionSkillMyDetail,
                meta: {
                  title: "极客-我的出题-详情",
                  breadcrumb: {
                    title: "详情",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: "examine",
        name: "QuestionExamine",
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            title: "题目审核"
          },
          breadcrumb: {
            title: "题目审核",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "QuestionExamineTask",
            redirect: { name: "QuestionExamineTaskSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionExamineTaskSelf",
                component: QuestionExamineTask,
                permission:
                  "question.api.fuwu_admin.skill_question_review_task.questions.index",
                meta: {
                  title: "极客-题目审核-审核任务",
                  nav: {
                    title: "审核任务"
                  },
                  breadcrumb: {
                    title: "审核任务",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "",
            redirec: { name: "QuestionExamineMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionExamineMySelf",
                component: QuestionExamineMy,
                permission:
                  "question.api.fuwu_admin.skill_question_review_task.questions.my.index",
                meta: {
                  title: "极客-题目审核-我的审核",
                  nav: {
                    title: "我的审核"
                  },
                  breadcrumb: {
                    title: "我的审核",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "QuestionDetail",
                component: QuestionDetail,
                permission:
                  "question.api.fuwu_admin.skill_question_review_task.questions.show"
              }
            ]
          }
        ]
      },
      {
        path: "examine_pro",
        name: "QuestionQualityInspection",
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            title: "题目质检"
          },
          breadcrumb: {
            title: "题目质检",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "QuestionQualityInspectionTask",
            redirect: { name: "QuestionQualityInspectionSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionQualityInspectionSelf",
                component: QuestionQualityInspection,
                permission:
                  "question.api.fuwu_admin.skill_question_review_task.questions.index",
                meta: {
                  title: "极客-题目质检-质检任务",
                  nav: {
                    title: "质检任务"
                  },
                  breadcrumb: {
                    title: "质检任务",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "QuestionQualityInspectionMy",
            redirect: { name: "QuestionQualityInspectionMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                permission:
                  "question.api.fuwu_admin.skill_question_review_task.questions.my.index",
                name: "QuestionQualityInspectionMySelf",
                component: QuestionQualityInspectionMy,
                meta: {
                  title: "极客-题目质检-我的质检",
                  nav: {
                    title: "我的质检"
                  },
                  breadcrumb: {
                    title: "我的质检",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: "spot",
        name: "SpotCheck",
        component: SpotCheck,
        permission:
          "question.api.fuwu_admin.skill_question_spot_check.tasks.index",
        meta: {
          title: "服务中心-题目抽检",
          nav: {
            icon: "el-icon-s-order",
            title: "题目抽检"
          },
          breadcrumb: {
            title: "题目抽检",
            replace: false
          }
        }
      },
      {
        path: "proofread",
        name: "QuestionProofread",
        component: { render: h => h("router-view") },
        meta: {
          nav: {
            icon: "el-icon-s-marketing",
            title: "翻译与校对"
          },
          breadcrumb: {
            title: "翻译与校对",
            replace: false
          }
        },
        children: [
          {
            path: "task",
            name: "QuestionProofreadTask",
            redirect: { name: "QuestionProofreadTaskSelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionProofreadTaskSelf",
                component: QuestionProofreadTask,
                permission:
                  "question.api.fuwu_admin.skill_question_verify_tasks.index",
                meta: {
                  title: "极客-翻译与校对-校对任务",
                  nav: {
                    title: "校对任务"
                  },
                  breadcrumb: {
                    title: "校队任务",
                    replace: false
                  }
                }
              }
            ]
          },
          {
            path: "my",
            name: "QuestionProofreadMy",
            redirect: { name: "QuestionProofreadMySelf" },
            component: { render: h => h("router-view") },
            children: [
              {
                path: "",
                name: "QuestionProofreadMySelf",
                component: QuestionProofreadMy,
                permission:
                  "question.api.fuwu_admin.skill_question_verify_tasks.my.index",
                meta: {
                  title: "极客-翻译与校对-我的校对",
                  nav: {
                    title: "我的校对"
                  },
                  breadcrumb: {
                    title: "我的校对",
                    replace: false
                  }
                }
              },
              {
                path: ":id",
                name: "QuestionProofreadMyDetail",
                component: QuestionProofreadMyDetail,
                permission:
                  "question.api.fuwu_admin.skill_question_verify.question.show",
                meta: {
                  title: "极客-翻译与校对-详情",
                  breadcrumb: {
                    title: "详情",
                    replace: false
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  }
];
